import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Text,
	TextAlignment,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { FocusLayerSizeV2, LayerHandleV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import { default as React, useContext } from 'react';
import { PortalContext } from '../../../context/PortalContext';
import { useTrackingManager } from '../../../tracking/useTrackingManager';

export const CloseFormLayer = ({
	setIsCloseFormLayerVisible,
	isCloseFormLayerVisible,
	setIsDataCollectionLayerVisible,
	closeFormLayerRef,
	dataCollectionLayerRef,
}: {
	setIsCloseFormLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	isCloseFormLayerVisible: boolean;
	setIsDataCollectionLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	closeFormLayerRef: React.RefObject<LayerHandleV2<any>>;
	dataCollectionLayerRef: React.RefObject<LayerHandleV2<any>>;
}): React.ReactElement => {
	const { layerManager } = useContext(PortalContext);

	const trackingManager = useTrackingManager();

	const handleContinue = () => {
		setIsCloseFormLayerVisible(false);

		if (closeFormLayerRef?.current) {
			closeFormLayerRef?.current.close();
			return ((closeFormLayerRef.current as any) = null);
		}
		return null;
	};

	const handleClose = () => {
		setIsDataCollectionLayerVisible(false);
		setIsCloseFormLayerVisible(false);
		trackingManager.trackClubVWLayerCloseClick('Data Collection Layer', { contentId: 'Data Collection' });

		if (dataCollectionLayerRef?.current && closeFormLayerRef?.current) {
			dataCollectionLayerRef.current.close();
			closeFormLayerRef.current.close();
			return ((dataCollectionLayerRef.current as any) = (closeFormLayerRef.current as any) = null);
		}
		return null;
	};

	const renderCloseFormLayer = () => {
		return (
			<Container wrap={'always'} padding={ContainerPadding.dynamic0150} horizontalAlign={'center'}>
				<Container wrap={'always'} gutter={ContainerGutter.dynamic0050}>
					<Text appearance={TokenTextAppearance.headline300} bold>
						¿Suficiente por hoy?
					</Text>
					<Text appearance={TokenTextAppearance.copy100}>
						¡No hay problema! Al cerrar, esta última pregunta se quedará sin contestar.
					</Text>
				</Container>
				<Container
					wrap={{ [Breakpoints.default]: 'always', [Breakpoints.b960]: 'never' }}
					horizontalAlign={'flex-start'}
					verticalAlign={'center'}
					padding={{ top: ContainerPadding.dynamic0100 }}
					gutter={ContainerGutter.static350}
					stretchContent
				>
					<CTA tag="button" emphasis="primary" onClick={handleContinue} aria-label="closePopUp" stretchContent>
						<Text textAlign={TextAlignment.center} bold>
							Quiero contestarla
						</Text>
					</CTA>
					<CTA tag="button" emphasis="secondary" onClick={handleClose} aria-label="closeForm" stretchContent>
						<Text textAlign={TextAlignment.center} bold>
							Prefiero seguir otro día
						</Text>
					</CTA>
				</Container>
			</Container>
		);
	};

	const renderInteractionLayer = (): any => {
		if (!closeFormLayerRef.current && isCloseFormLayerVisible) {
			const layer = layerManager.openFocusLayer(
				renderCloseFormLayer,
				{},
				{
					size: FocusLayerSizeV2.A,
					shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
				},
			);
			(closeFormLayerRef.current as any) = layer;
		}
		return null;
	};

	return <>{isCloseFormLayerVisible && renderInteractionLayer()}</>;
};
